import { type CatalogSortBy } from '~/domains/category';

export default function userPreferencesSortingSerializer(
  sorting?: string,
): CatalogSortBy | undefined {
  return sorting !== undefined ? JSON.parse(sorting) : undefined;
}
